import { debounce } from 'lodash';
import { useSocketContext } from 'modules/POS/Cashier/hooks/useSocket';
import shopService from 'modules/shop/services';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';

const POSCustomerLayout = () => {
  const { shop_id = '' } = useParams<{ shop_id: string }>();
  const dispatch = useDispatch();
  const socket = useSocketContext();
  const initConnectSocket = debounce(() => socket.connect(), 200);
  useEffect(() => {
    initConnectSocket();
    dispatch(shopService.actions.initData(shop_id));
    return () => {
      socket.unsubscribeAll();
    };
  }, []);
  return (
    <>
      <Outlet />
    </>
  );
};

export default POSCustomerLayout;
